import { fg } from '@atlassian/jira-feature-gating';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import QUERY from '@atlassian/jira-servicedesk-virtual-agent-knowledge-base-touchpoint/src/ui/__generated__/VirtualServiceAgentCtaCardQuery$parameters';
import type { VirtualServiceAgentCtaCardQuery } from '@atlassian/jira-servicedesk-virtual-agent-knowledge-base-touchpoint/src/ui/__generated__/VirtualServiceAgentCtaCardQuery.graphql';

export const virtualAgentKnowledgebaseTouchpointResource =
	createRelayResource<VirtualServiceAgentCtaCardQuery>({
		type: 'SERVICEDESK_VIRTUAL_AGENT_KNOWLEDGE_BASE_TOUCHPOINT',
		isBrowserOnly: true,
		getQuery: ({ match }, { tenantContext }) => ({
			parameters: QUERY,
			variables: {
				cloudId: tenantContext.cloudId,
				key: match.params.projectKey || '',
				checkForAiEnabledFF: fg('require_ai_enabled_for_jsm_virtual_agent'),
			},
		}),
	});
